var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/password/hidden") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/password/hidden",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7746407,20.661961 C23.8990387,20.7613842 24,20.9713632 24,21.1306235 C24,21.2470384 23.9408587,21.4152339 23.8680216,21.5060515 L23.493033,21.9744209 C23.3935732,22.0985993 23.1837774,22.1994141 23.0246636,22.1994141 C22.9084317,22.1994141 22.7404193,22.1404559 22.649675,22.0678019 L0.225359334,4.53745308 C0.100961274,4.43802985 0,4.2280509 0,4.06879063 C0,3.95237572 0.0591412616,3.78418017 0.131978394,3.69336263 L0.50696695,3.22499313 C0.606426806,3.10081479 0.816222649,3 0.975336446,3 C1.09156825,3 1.2595807,3.05895816 1.350325,3.13161219 L23.7746407,20.661961 Z M11.129653,8.49244713 C11.3672068,8.4418017 11.7570997,8.40027465 12,8.39983521 C14.2679484,8.39983521 16.100888,10.1964112 16.1841252,12.4440721 L11.129653,8.49244713 Z M12.870347,16.7073332 C12.6327932,16.7577222 12.2428637,16.7990662 12,16.7995789 C9.73245445,16.7995789 7.89951479,15.0030028 7.81587476,12.7557081 L12.870347,16.7073332 Z M12,7.19987183 C11.2545271,7.19987183 10.5270347,7.3048613 9.81682688,7.46609906 L8.07649913,6.10526412 C9.31095853,5.66241875 10.6237847,5.39992676 12,5.39992676 C16.6097226,5.39992676 20.6356129,8.08446398 22.6710611,12.0522384 C22.7430559,12.1946901 22.801538,12.4398975 22.801538,12.5995239 C22.801538,12.7591504 22.7430559,13.0043578 22.6710611,13.1468095 C22.2315847,14.0002746 21.3428911,15.2620892 20.687357,15.9633617 L19.2721414,14.8571455 C19.8096127,14.2940767 20.548787,13.2827428 20.922091,12.599707 C19.0906528,9.26230889 15.6992768,7.19987183 12,7.19987183 Z M12,17.9995423 C12.7458391,17.9995423 13.4729653,17.8945528 14.1831731,17.7336812 L15.9235009,19.09415 C14.6890415,19.5351277 13.3762153,19.7994873 12,19.7994873 C7.3906436,19.7994873 3.36475327,17.1149501 1.33120937,13.1471757 C1.25917788,13.004724 1.2007324,12.7595166 1.2007324,12.5998901 C1.2007324,12.4402637 1.25917788,12.1950563 1.33120937,12.0526046 C1.77057585,11.1992493 2.65908633,9.93761787 3.31451067,9.23641857 L4.72972627,10.3426348 C4.1917422,10.9055205 3.45172572,11.9166712 3.077909,12.599707 C4.90971345,15.9371052 8.30072324,17.9995423 12,17.9995423 Z",
    id: "eye-slash",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.c650118f.svg";
export { ForwardRef as ReactComponent };